import MovieCarouselCard from "pages/videoPage/shared/MovieCarouselCard";
import NoFavorite from "./NoFavorite";
import { useEffect, useState } from "react";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import { RouteName } from "constant/routeNames";
import "swiper/css";
import "swiper/css/pagination";

function VideosByUser({ user, favorite, favoriteData }: any) {
  // const favoriteData = useSelector((state: any) => state?.user?.userFavorites);

  const [videos, setVideos] = useState<any>([]);
  const allVideos = favoriteData?.favorite_movies || [];

  useEffect(() => {
    setVideos(allVideos);
  }, []);
  return (
    <div>
      {/* top section */}
      <div className="flex justify-between mb-8 w-[95%] ml-6 mt-8 max-sm:w-full max-sm:mx-0">
        <h2 className="text-xl font-medium text-white lg:text-xl md:text-xl">
          {/* Videos by User */}
          Favourite Videos
        </h2>
        {/* <Link to={RouteName.SeeAllDiscoverPlaylistsRoute}>
          <p className="font-[500] pr-4 text-[15px] text-[#F50537] cursor-pointer">
            See all
          </p>
        </Link> */}
      </div>
      {/* card section */}
      {allVideos?.length === 0 && allVideos ? (
        <NoFavorite text="Movies" />
      ) : (
        // <div>
        //   <div className="mt-4 mb-5 w-[95%] grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 max-sm:mx-auto max-sm:w-full max-sm:gap-4">
        //     {videos.length > 0 &&
        //       videos.map((card: any, i: any) => (
        //         <div key={i}>
        //           <div className="mx-3 my-1 max-sm:mx-0">
        //             <MovieCarouselCard
        //               id={card.id}
        //               time={card.runtime}
        //               title={card.title}
        //               info={card.title}
        //               year={card.release}
        //               type={card.genre}
        //               img={card.thumbnail_url}
        //               slug={card.slug}
        //               user={user}
        //               favoriteMovies={favorite}
        //               movie={card}
        //             />
        //           </div>
        //         </div>
        //       ))}
        //   </div>
        // </div>
        <div className="">
          <Swiper
            slidesPerView={7}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              380: {
                slidesPerView: 2,
              },
              700: {
                slidesPerView: 3,
              },
              1000: {
                slidesPerView: 4,
              },
              1200: {
                slidesPerView: 5,
              },
              1400: {
                slidesPerView: 6,
              },
              1600: {
                slidesPerView: 7,
              },
            }}
            modules={[Pagination, Navigation]}
            navigation={true}
            className="mt-8 mb-10 mySwiper "
          >
            {allVideos?.length > 0 &&
              allVideos?.map((card: any, i: number) => (
                <SwiperSlide key={i}>
                  <div className="mx-3 max-sm:mx-1">
                    <MovieCarouselCard
                      id={card?.id}
                      time={card?.runtime}
                      title={card?.title}
                      info={card?.title}
                      year={card?.release}
                      type={card?.genre}
                      img={card?.thumbnail_url}
                      thumbnail={card?.thumbnail}
                      slug={card?.slug}
                      user={user}
                      favoriteMovies={favorite}
                      movie={card}
                      first_episode={card?.firstEpisode}
                      plan_id={card?.plan_id}
                    />
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
        </div>
      )}
    </div>
  );
}

export default VideosByUser;
